import { render, staticRenderFns } from "./transAcctS.vue?vue&type=template&id=b9c8a5a0&scoped=true&"
import script from "./transAcctS.vue?vue&type=script&lang=js&"
export * from "./transAcctS.vue?vue&type=script&lang=js&"
import style0 from "./transAcctS.vue?vue&type=style&index=0&id=b9c8a5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c8a5a0",
  null
  
)

export default component.exports